import {
  Anchor,
  Award,
  Biohazard,
  Bird,
  Bolt,
  Bomb,
  BrickWall,
  Bug,
  Building,
  Calendar,
  CalendarCheck,
  Castle,
  Cat,
  Clock,
  Coins,
  Crosshair,
  Crown,
  Diamond,
  Dog,
  Feather,
  Flag,
  FlagTriangleRight,
  Flame,
  Gamepad2,
  Gem,
  Ghost,
  Gift,
  GraduationCap,
  Hammer,
  Heart,
  HeartPulse,
  Leaf,
  Medal,
  Moon,
  Mountain,
  PartyPopper,
  PawPrint,
  Pickaxe,
  Rabbit,
  Repeat,
  Rocket,
  Shield,
  ShieldHalf,
  Skull,
  Snowflake,
  Sparkles,
  Star,
  Sun,
  Sword,
  Swords,
  Target,
  TrendingUp,
  Trophy,
  Turtle,
  Users,
  Zap,
  type LucideIcon,
} from 'lucide-preact';

/** Icons referenced by name from content data (modes, gadgets, achievements, emblems). */
export const ICONS: Record<string, LucideIcon> = {
  anchor: Anchor,
  award: Award,
  biohazard: Biohazard,
  bird: Bird,
  bolt: Bolt,
  bomb: Bomb,
  'brick-wall': BrickWall,
  bug: Bug,
  building: Building,
  calendar: Calendar,
  'calendar-check': CalendarCheck,
  castle: Castle,
  cat: Cat,
  clock: Clock,
  coins: Coins,
  crosshair: Crosshair,
  crown: Crown,
  diamond: Diamond,
  dog: Dog,
  feather: Feather,
  flag: Flag,
  'flag-triangle-right': FlagTriangleRight,
  flame: Flame,
  'gamepad-2': Gamepad2,
  gem: Gem,
  ghost: Ghost,
  gift: Gift,
  'graduation-cap': GraduationCap,
  hammer: Hammer,
  heart: Heart,
  'heart-pulse': HeartPulse,
  leaf: Leaf,
  medal: Medal,
  moon: Moon,
  mountain: Mountain,
  'party-popper': PartyPopper,
  'paw-print': PawPrint,
  pickaxe: Pickaxe,
  rabbit: Rabbit,
  repeat: Repeat,
  rocket: Rocket,
  shield: Shield,
  'shield-half': ShieldHalf,
  skull: Skull,
  snowflake: Snowflake,
  sparkles: Sparkles,
  star: Star,
  sun: Sun,
  sword: Sword,
  swords: Swords,
  target: Target,
  'trending-up': TrendingUp,
  trophy: Trophy,
  turtle: Turtle,
  users: Users,
  zap: Zap,
};

export function Icon(props: { name: string; size?: number; class?: string; strokeWidth?: number; color?: string }) {
  const C = ICONS[props.name] ?? Award;
  return <C size={props.size ?? 20} class={props.class} strokeWidth={props.strokeWidth ?? 2.25} color={props.color} />;
}

/** Icons offered in the clan emblem builder (index = ClanEmblem.icon). */
export const EMBLEM_ICONS = [
  'skull', 'crown', 'flame', 'zap', 'star', 'swords', 'shield', 'rocket', 'bomb', 'target', 'hammer', 'pickaxe',
  'ghost', 'paw-print', 'bird', 'cat', 'dog', 'rabbit', 'turtle', 'bug', 'anchor', 'snowflake', 'sun', 'moon',
  'leaf', 'mountain', 'castle', 'diamond', 'heart', 'feather', 'trophy', 'sword',
];
